<template>
  <div class="announcement">
    <div class="box">
      <div class="img fl">
        <span :class="{sp1:lang=='hk'}"></span>
      </div>
      <div class="text fl">
        <Row class="content">
          <Col span="2" class="t">
            <span>{{$t('title.w6')}}</span>
          </Col>
          <Col span="22" class="scroll">
            <div class="swiper-container" id="swiper2">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(text, i) in news" :key="i">
                  <router-link :to="{name:'noticeDetail',query:{id:text.Id}}" class="scroll_box">
                    <span class="fl">{{text.Subject}}</span>
                    <span class="fr">{{text.CreatedAt}}</span>
                  </router-link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row class="content">
          <Col span="2" class="t_1">
            <span>{{$t('title.w7')}}</span>
          </Col>
          <Col span="22" class="scroll">
            <div class="swiper-container" id="swiper3">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(information, i) in Informations" :key="i">
                  <router-link :to="{name:'newsDetail',query:{id:information.Id}}" class="scroll_box">
                    <span class="fl">{{information.Subject}}</span>
                    <span class="fr">{{information.CreatedAt}}</span>
                  </router-link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper"
import {getOnce} from '@/libs/axios'
export default {
  data() {
    return {
      news: [],
      Informations:[]
    };
  },
  methods: {
    initSwiperText() {
      var mySwiper2 = new Swiper("#swiper2", {
        autoplay: {
          delay: 6500,
          disableOnInteraction: false
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        speed: 500,
        direction: "vertical", // 垂直切换选项
        loop: true // 循环模式选项
      });
       mySwiper2.el.onmouseover = function(){
        mySwiper2.autoplay.stop();
      }
       mySwiper2.el.onmouseout = function(){
        mySwiper2.autoplay.start();
      }
    },
    initSwiperText1() {
      var mySwiper3 = new Swiper("#swiper3", {
        autoplay: {
          delay: 6500,
          disableOnInteraction: false
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        speed: 500,
        direction: "vertical", // 垂直切换选项
        loop: true // 循环模式选项
      });
       mySwiper3.el.onmouseover = function(){
        mySwiper3.autoplay.stop();
      }
       mySwiper3.el.onmouseout = function(){
        mySwiper3.autoplay.start();
      }
    }
  },
  mounted() {
    getOnce('/Member/RZJPageIndex/GetNews')
    .then(res => {
      this.Informations = res.Informations;
      this.news = res.News;
      this.$nextTick(() => {
        this.initSwiperText(), this.initSwiperText1();
      });
    })
  },
   computed: {
    lang() {
      return this.$i18n.locale;
    }
  }
};
</script>

<style lang="less" scoped>
.swiper-container{
  height: 20px;
}
.announcement {
  width: 1200px;
  height: 80px;
  position: absolute;
  top: -110px;
  z-index: 20;
  background: #fff;
  border-radius: 4px;
  .box {
    width: 1200px;
    height: 80px;
    .img {
      width: 110px;
      height: 80px;
      span {
        background: url("../assets/index_news.png") left no-repeat;
        background-size: 49px 50px;
        width: 49px;
        height: 50px;
        display: inline-block;
        margin: 15px 30px;
        position: relative;
        &::after {
          width: 1px;
          height: 40px;
          position: absolute;
          left: 65px;
          top: 1px;
          display: block;
          content: "";
          background: linear-gradient(
            180deg,
            rgba(249, 250, 249, 1) 0%,
            rgba(225, 225, 225, 1) 50%,
            rgba(249, 250, 249, 1) 100%
          );
        }
      }
      .sp1{
        background: url("../assets/index_news1.png") left no-repeat;
        background-size: 49px 50px;
      }
    }
    .text {
      margin: 15px 0;
      .content {
        width: 1090px;
        height: 30px;
        .t {
          height: 20px;
          width: 58px;
          border-radius: 2px;
          border: 1px solid rgba(94, 143, 252, 1);
          text-align: center;
          span {
            width: 48px;
            height: 17px;
            font-size: 12px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(94, 143, 252, 1);
            line-height: 17px;
          }
        }
        .scroll {
          height: 20px;
          overflow: hidden;
          .swiper-slide {
            height: 20px;
          }
          .scroll_box {
            display: block;
            width: 100%;
            height: 20px;
            position: relative;
            span {
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC-Regular;
              font-weight: 400;
              color: rgba(35, 35, 37, 1);
              line-height: 20px;
            }
            span:first-child {
              margin-left: 10px;
            }
            span:last-child {
              margin-left: 10px;
              color: rgba(123, 123, 124, 1);
              background: url("../assets/pubilc_more.png") right no-repeat;
              background-size: 5px 11px;
              padding-right: 10px;
              text-align: center;
            }
          }
        }
        .t_1 {
          height: 20px;
          width: 58px;
          border-radius: 2px;
          border: 1px solid rgba(255, 98, 8, 1);
          text-align: center;
          span {
            width: 48px;
            height: 17px;
            font-size: 12px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(255, 98, 8, 1);
            line-height: 17px;
          }
        }
      }
    }
  }
}
</style>
